/**
 * Created by chenqifeng on 2016/8/31.
 */

import url from '../util/url';
import maple from 'maple';
import domain from '../domain';
import * as api from '../api/index';
import {setCookie,getCookie,removeCookie} from '../util/cookie';

let positionRun = function(deferred){
    let params = url.getUrlParams();
    let cookie = getCookie();
    /**
     * url上带入城市信息，请求城市名
     */
    if(params.cityId || params.cityid){
        api.base.cityList({
            data:{id:params.cityId || params.cityid},
            tgError:function(){
                deferred.resolve(2554,'大连');
            },
            error:function(){
                deferred.resolve(2554,'大连');
            },
            success:function(data){
                let cityId,cityName;
                if(data.length){
                    cityId = data[0].id;
                    cityName = data[0].name;
                }else{
                    cityId = 2554;
                    cityName = '大连';
                }
                _gpsPosition();
                deferred.resolve(cityId,cityName);
            }
        })
    }
    //第一次进入，cookie中没有city信息
    else if(!cookie.cityId || !cookie.cityName){
        _gpsPosition();
        deferred.resolve(2554,'大连');
    }
    //非第一次进入，cookie中有city信息
    else{
        _gpsPosition();
        deferred.resolve(cookie.cityId,cookie.cityName);
    }
};

let _gpsPosition = function(){
    var pathname = location.pathname
        , options
        ;
    
    // 没有进行过定位，当前页面是首页或者城市惠页面
    if( !getCookie('isGPS')
        && (pathname === '/'
            || pathname === '/index.html'
            || pathname === '/discover/index.html') ){

        console.log('进入定位');

        try {
            options = {
                timeout : 2000
                , enableHighAccuracy : true
                , maximumAge : 5000
            };

            setTimeout(function() {
                if(maple.device('weixin')){
                    wx.ready(function(){
                        wx.getLocation({
                            success: function ({latitude, longitude}) {
                                _updateGPSDate(latitude, longitude);
                            },
                            fail: function () {
                                setCookie('isGPS', true);
                            }
                        })
                    })
                }else{
                    navigator.geolocation.getCurrentPosition(function({coords={}}){
                        let { latitude
                            , longitude } = coords
                            ;

                        _updateGPSDate(latitude, longitude);
                    }, function(){
                        // alert('gps error')
                        /* 定位城市失败 */
                        setCookie('isGPS', true);
                    }, options);
                }
            }, 100);
        }
        catch(e){
            // alert('cache error')
            /* 定位城市失败 */
            setCookie('isGPS', true);
        }
    }
};

let _updateGPSDate = function (lat, lon) {
    try{
        //alert('gps success')
        /*返回结果都不是*/
        if(!isNaN(lat) && !isNaN(lat)) {
            /*定位成功*/
            setCookie('isGPS', true,'1d');
            // 取得GPS定位城市
            _getGPSCity(lat, lon);
        } else {
            /*定位城市失败*/
            setCookie('isGPS', true);
        }
    }catch(e){
        //alert('getCurrentPosition error')
        setCookie('isGPS', true);
    }
};

let _getGPSCity = function(lat,lon){
    api.base.judgeStoreByCity({
        data:{
            longitude:lon,
            latitude:lat
        },
        success:function(data){
            if(data){
                api.base.cityLocate({
                    data:{latitude:lat,longitude:lon},
                    success:function(data){
                        var cityId,
                            cityName;
                        try {
                            cityId = data.id;
                            cityName = data.name;
                            //alert(cityId)
                            //alert(cityName)
                            if(cityId != maple.cookie('cityId') && cityId != null){
                                getCookie('cityName')&& maple.confirm({
                                    title:"提示信息",
                                    content:"您当前选择的城市为" + getCookie('cityName') + "，是否切换至" + cityName + "？",
                                    okFn:function(){
                                        setCookie('cityId',cityId,'365d');
                                        setCookie('cityName',cityName,'365d');
                                        removeCookie('storeId');
                                        setCookie('lat', lat,'1d');
                                        setCookie('lon', lon,'1d');
                                        maple.url().replace('cityId');
                                        maple.url().replace('storeId');
                                        maple.url().replace('source');
                                        location.reload();
                                    }
                                });
                            }
                        } catch(e) {
                            //that.lat = undefined;
                            //that.lon = undefined;
                        }
                        setCookie('lat', lat,'1d');
                        setCookie('lon', lon,'1d');
                    }
                });
            }
        },
        tgError:function(){
            api.base.cityLocate({
                data:{latitude:lat,longitude:lon},
                success:function(data){
                    var cityId,
                        cityName;
                    try {
                        cityId = data.id;
                        cityName = data.name;
                        //alert(cityId)
                        //alert(cityName)
                        if(cityId != maple.cookie('cityId') && cityId != null){
                            getCookie('cityName')&& maple.confirm({
                                title:"提示信息",
                                content:"您当前选择的城市为" + getCookie('cityName') + "，是否切换至" + cityName + "？",
                                okFn:function(){
                                    setCookie('cityId',cityId,'365d');
                                    setCookie('cityName',cityName,'365d');
                                    removeCookie('storeId');
                                    setCookie('lat', lat,'1d');
                                    setCookie('lon', lon,'1d');
                                    maple.url().replace('cityId');
                                    maple.url().replace('storeId');
                                    maple.url().replace('source');
                                    location.reload();
                                }
                            });
                        }
                    } catch(e) {
                        //that.lat = undefined;
                        //that.lon = undefined;
                    }
                    setCookie('lat', lat,'1d');
                    setCookie('lon', lon,'1d');
                }
            });
        }
    });
};

export {positionRun}